module.exports = __webpack_public_path__ + "static/media/logo-full-white.4aed3914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-full-white.png
// module id = 849
// module chunks = 0